import { defineStore } from 'pinia'

interface User {
  id: number
  name: string
  email: string
  idmedico?: number
  session?: number
  admin?: boolean
  protocol?: number
}
interface UserPayloadInterface {
  username: string
  password: string
  birthdate?: string
}

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as User | null
  }),
  getters: {
    token: () => useAuthToken().getToken()
  },
  persist: {
    storage: typeof window !== 'undefined' ? localStorage : undefined
  },
  actions: {
    async signAzure(token: string): Promise<boolean> {
      const data = await useHttp('auth/azure', { method: 'post', body: token })
      if (data?.token?.bearer) {
        useAuthToken().setToken(`Bearer ${data.token.bearer}`)
        return true
      }
      return false
    },
    async signIn({ username, password, birthdate }: UserPayloadInterface): Promise<boolean> {
      const data = await useHttp('auth/login', {
        method: 'post',
        body: {
          username,
          password,
          birthdate: birthdate ? birthdate.split('-').reverse().join('/') : undefined,
          module: useRouterStore().moduleId
        }
      })
      if (data?.token?.bearer) {
        useAuthToken().setToken(`Bearer ${data.token.bearer}`)
        return true
      }
      return false
    },
    async refreshToken() {
      const data = await useHttp('auth/token', { spinner: false })
      if (data?.token?.bearer)
        useAuthToken().setToken(`Bearer ${data.token.bearer}`)
    },
    async recoveryPassword(payload) {
      return await useHttp('auth/recovery', { method: 'post', body: { module: useRouterStore().moduleId, ...payload } })
    },
    async updatePassword(payload) {
      return await useHttp('auth/password', { method: 'post', body: { module: useRouterStore().moduleId, ...payload } })
    },
    async signOut(): Promise<boolean> {
      const response = await navigateTo('/signout')
      if (response)
        return false
      useAuthToken().clearToken()
      this.user = null // clear the user state
      return true
    },
    async getSession() {
      this.user = await useHttp('auth/session', { method: 'post', body: { module: useRouterStore().moduleId } }).catch(() => null)
    },
    async getChat(user: number) {
      return await useHttp('auth/chat', { method: 'post', body: { user } }).catch(() => [])
    },
    async getMessage() {
      return await useHttp('auth/mesg', { method: 'post' }).catch(() => [])
    }
  }
})
